import { EmptyStatePage } from '../EmptyStatePage';
import { Button } from '@nexelem/components';
import { useGroupedQueuesStore } from './store';
import { useCustomTranslation } from '../../../hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/pro-light-svg-icons';

const Actions = () => {
  const showAll = useGroupedQueuesStore((state) => state.showAll);
  const { tWrapper } = useCustomTranslation('products.productionPlan.gantt.emptyState');

  return (
    <Button className="shrink-0" StartIcon={<FontAwesomeIcon icon={faEye} />} variant="outlined" onClick={showAll}>
      {tWrapper('button')}
    </Button>
  );
};

export const ProductionPlanEmptyState = () => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.gantt.emptyState');

  return <EmptyStatePage Actions={<Actions />} text={tWrapper('title')} />;
};
